import {Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-schedule-template-planingarea-informer',
    templateUrl: './schedule-template-planingarea-informer.component.html',
    styleUrls: ['./schedule-template-planingarea-informer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScheduleTemplatePlaningareaInformerComponent implements OnInit {
  @Input() item;
  @Input() individual = false;
  @Output() clicked: EventEmitter<any> =  new EventEmitter<any>();
  public groupedPlanningAreas;
  constructor() { }

  ngOnInit() {
    this.groupedPlanningAreas = this.groupByPlaningArea(this.item.planningareas);
  }

  groupByPlaningArea(items) {

    const scheduleTypes = items
                            .map(_item => _item.scheduletype)
                            .filter((_value, _index, _self) => _self.indexOf(_value) === _index);
    const pa = scheduleTypes.map(scheduletype => ({
      scheduletype,
      timeranges: items.filter(_item => _item.scheduletype === scheduletype).map(_item => _item.timeranges[0])}));
    return pa;
  }

  clickedHandle() {
    this.clicked.emit({item: this.item});
  }
}
